module.exports = __webpack_public_path__ + "static/img/img_title_de.64b9165.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newYear-2023/img_title_de.png
// module id = u6oN
// module chunks = 1